import type {FrontendTf1Season, FrontendTf1Video} from '@repo/shared/api/tf1';

export interface Tf1SeasonGroup {
  season: FrontendTf1Season;
  videos: FrontendTf1Video[];
  downloaded: number;
  episodeParts: number;
}

export function groupTf1Seasons(
  seasons: FrontendTf1Season[],
  videos: FrontendTf1Video[],
): Tf1SeasonGroup[] {
  const groups = new Map(
    seasons.map(season => [
      season.id,
      {season, videos: [] as FrontendTf1Video[], downloaded: 0, episodeParts: 0},
    ]),
  );
  for (const video of videos) {
    let group = groups.get(video.listId);
    if (!group) {
      group = {
        season: {
          id: video.listId,
          season: video.season,
          label: video.season === undefined ? 'Extras' : `Season ${video.season}`,
          reportedVideoCount: 0,
        },
        videos: [],
        downloaded: 0,
        episodeParts: 0,
      };
      groups.set(video.listId, group);
    }
    group.videos.push(video);
    if (video.kind === 'episode') group.episodeParts++;
    if (video.kind === 'episode' && video.state === 'complete') group.downloaded++;
  }
  for (const group of groups.values())
    group.videos.sort(
      (a, b) =>
        (b.episode ?? -1) - (a.episode ?? -1) ||
        (a.part ?? 0) - (b.part ?? 0) ||
        a.title.localeCompare(b.title),
    );
  return [...groups.values()].sort(
    (a, b) =>
      (b.season.season ?? -1) - (a.season.season ?? -1) ||
      a.season.label.localeCompare(b.season.label),
  );
}
